import { lazy } from 'react';

const History = lazy(() => import('../pages/History/'));
const RevisionHistory = lazy(() => import('../pages/History/Revision'));

const historyRoute = {
  public: [],
  auth: [
    {
      name: 'history',
      path: '/history',
      component: History,
    },
    {
      name: 'history_revisions',
      path: '/history/revisions',
      component: RevisionHistory,
    },
  ],
};

export default historyRoute;
